import icon from "../../assets/waves.svg";
import type { Property } from "../../types";

export const radio6Ghz: Property = {
  id: "radio6Ghz",
  title: "radio6Ghz.title",
  icon,
};
